---
title: "条款与条件"
path: "/zh/条款与条件"
seoTitle: "条款与条件 | Dutch Passion Thailand"
seoDescription: "在 Dutch Passion Thailand 购买大麻种子时关于订购、付款、配送、取消与退货的条款摘要。下单前请阅读。"
---

> **本简体中文版为摘要，且由机器翻译产生。**具有法律效力的是
> [英文版条款与条件](/terms-and-conditions)。如有出入，以英文版为准。
> 本页正在等待母语者校对。

## 适用范围

本条款适用于在 dutchpassion.co.th 提交的所有订单。确认下单即视为您同意本条款。

## 订购与付款

显示价格以泰铢计价并含税。您可以选择货到付款、信用卡／借记卡、PromptPay 或手机银行
付款。卡片信息直接发送至支付服务商 Omise，不会经过本网站。

## 配送

工作日 15:00 前的订单当天发出。包装为隐私包装，从外包装看不出内容物。配送范围仅限
泰国境内：普通邮寄配送全泰国（含曼谷）均为 100 泰铢，通常 1–3 个工作日送达。曼谷市内另可
选择当日送达服务，费用为 250 泰铢。

## 取消与退货

在发货之前，您可以提供订单编号联系我们取消或修改订单。无论是否拆封，种子一律不予退货，已送达的订单也不予退款。若商品存在瑕疵或与订单
不符，请与我们联系。

## 适用法律

本条款受泰王国法律管辖。如有疑问，请发送邮件至 info@dutchpassion.co.th。
